import type { BaseWidgetsTabsKey, WidgetTab } from '@mwl/core-lib';

export const getAnalyticsData = (line_id: string, tab: WidgetTab<BaseWidgetsTabsKey>) => {
  const targetTab = {
    broadcast: 'lineInfo_widget_broadcast_click',
    stats: 'lineInfo_widget_statistic_click',
    graph: 'lineInfo_widget_graphics_click',
    match: 'lineInfo_widget_match_click',
  };

  return {
    click: {
      eventName: targetTab[tab.key],
      data: {
        line_id,
        text: tab.label as string,
      },
    },
  };
};
